import { PromptTemplateCategory } from '../types';

export const dialogue: PromptTemplateCategory = {
  title: "対話",
  icon: "💬",
  templates: [
    {
      title: "ポッドキャストインタビューテンプレート",
      content: `2人の話者によるポッドキャスト形式のインタビューを書いてください。
- 話者1はホスト：[好奇心旺盛で熱心なテックジャーナリスト]。
- 話者2はゲスト：[画期的な論文を発表したばかりの著名なAI研究者]。
- 議論のトピックは[クリエイティブ分野における人間とAIの協力の未来]。
- トーンは[会話的で、洞察に富み、時にはユーモラス]であるべきです。
- フォローアップの質問やエピソードを含む自然なやり取りを入れてください。

各行を「Speaker 1:」または「Speaker 2:」の形式で、その後に対話を記述してください。`,
      mode: 'multi'
    },
    {
      title: "ディベートテンプレート",
      content: `対立する観点を持つ2人の話者による構造化されたディベートを書いてください。
- 話者1は[リモートワークが恒久的なデフォルトになるべきだ]と主張します。
- 話者2は[イノベーションにはオフィスでの協力が不可欠だ]と主張します。
- 両方の話者が[実際の例を用いた十分に裏付けられた議論]を提示すべきです。
- トーンは[敬意を持ちつつも情熱的]であるべきです。
- 各話者は相手の主張に直接応答すべきです。

各行を「Speaker 1:」または「Speaker 2:」の形式で、その後に対話を記述してください。`,
      mode: 'multi'
    },
    {
      title: "語学学習ダイアログテンプレート",
      content: `語学学習者向けの2人の話者による会話ダイアログを書いてください。
- シナリオは[にぎやかな屋台で料理を注文すること]。
- 話者1は[おすすめの料理を紹介するフレンドリーな地元の屋台主]。
- 話者2は[初めて現地の料理を試す旅行者]。
- [自然なためらい、丁寧な表現、文化的な文脈]を含めてください。
- ダイアログは本物らしく、学習者が[日常会話のフレーズ]を習得するのに役立つものであるべきです。

各行を「Speaker 1:」または「Speaker 2:」の形式で、その後に対話を記述してください。`,
      mode: 'multi'
    }
  ]
};
